import React, { useState } from 'react';
import { Link, Navigate, useNavigate } from 'react-router-dom';
import { useAdminAuth } from '../../contexts/AdminAuthContext';
import Logo from '../../components/Logo';

const AdminLogin = () => {
  const { requestOtp, isAuthenticated } = useAdminAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  if (isAuthenticated()) return <Navigate to="/admin" replace />;

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSubmitting(true);
    const res = await requestOtp(form);
    setSubmitting(false);
    if (res.success) {
      navigate('/admin/verify');
    } else {
      setError(res.error || 'Login failed');
    }
  };

  return (
    <div className="admin-auth-page">
      <nav className="admin-auth-nav">
        <div className="admin-auth-nav-inner">
          <div className="admin-brand">
            <Logo height={30} />
          </div>
          <Link to="/login" className="admin-auth-nav-link">← Back to app</Link>
        </div>
      </nav>

      <div className="admin-auth-wrap">
        <div className="admin-auth-card">
          <h1>Admin sign in</h1>
          <p className="admin-auth-sub">Verification code is emailed after password check.</p>
          <form onSubmit={handleSubmit}>
            <label>Email</label>
            <input
              type="email"
              name="email"
              value={form.email}
              onChange={handleChange}
              autoComplete="username"
              required
            />
            <label>Password</label>
            <input
              type="password"
              name="password"
              value={form.password}
              onChange={handleChange}
              autoComplete="current-password"
              required
            />
            {error && <div className="admin-auth-error">{error}</div>}
            <button type="submit" disabled={submitting}>
              {submitting ? 'Sending code…' : 'Continue'}
            </button>
          </form>
          <Link to="/login" className="admin-auth-link">← Back to user login</Link>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
